import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M16.841 14.375v-6.25c0-.92-.746-1.667-1.666-1.667H4.758v7.917c0 .92.746 1.667 1.667 1.667h8.75c.92 0 1.666-.747 1.666-1.667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="m12.05 6.25-.777-1.423a1.667 1.667 0 0 0-1.463-.869H6.425c-.92 0-1.667.747-1.667 1.667v3.542" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);